import React, { useState } from "react";
import "./Pagination.scss";
export interface Props {
  itemPerPageProp: number;
  totalPagesProp: any;
  onPageChange: (page: number) => void;
  paginationFunction?: (page: number) => void;
  paginationStyle?: React.CSSProperties;
  paginationListStyle?: React.CSSProperties;
  paginationItemStyle?: React.CSSProperties;
  paginationLinkStyle?: React.CSSProperties;
}
const Pagination = ({
  itemPerPageProp,
  totalPagesProp,
  paginationFunction,
  onPageChange,
  paginationStyle,
  paginationListStyle,
  paginationItemStyle,
  paginationLinkStyle,
}: Props) => {
  const pageNumbers = [];
  let itemPerPage = itemPerPageProp;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalPagesProp / itemPerPage);
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    onPageChange(page);
    if (paginationFunction) {
      paginationFunction(page);
    }
  };

  return (
    <nav role="navigation" aria-label="Pagination Navigation" style={paginationStyle && paginationStyle}>
      <ul className="mfg-pagination" style={paginationListStyle && paginationListStyle}>
        <li className={`previous`} style={paginationItemStyle && paginationItemStyle}>
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1 ? true : false}
            style={paginationLinkStyle && paginationLinkStyle}
          >
            Prev
          </button>
        </li>
        {pageNumbers.map((number: number) => (
          <li key={number} className={currentPage === number ? "active" : ""} style={paginationItemStyle && paginationItemStyle}>
            <button
              onClick={() => {
                handlePageChange(number);
                if (paginationFunction) {
                  paginationFunction(number);
                }
              }}
              aria-current={currentPage === number ? "true" : "false"}
              style={paginationLinkStyle && paginationLinkStyle}
            >
              {number}
            </button>
          </li>
        ))}
        <li className={`next`} style={paginationItemStyle && paginationItemStyle}>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages ? true : false}
            style={paginationLinkStyle && paginationLinkStyle}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
